export const PADDING = 16;
export const BORDER_HEIGHT = 5;

export const TAG_HEIGHT = 24;
export const TAG_PADDING = 10;
export const TAG_GAP = 7;
export const TAG_MAX_WIDTH = 100;
export const TAG_ROW_WIDTH = 210;
